import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';

export class NewsletterChangeEvent {
    constructor(
        public readonly email: string | undefined,
        public readonly subscribed: boolean,
        public readonly data: Newsletter.ISubscribeRequest | Newsletter.IUnsubscribeRequest
    ) {}
}
